// extracted by mini-css-extract-plugin
export default {"layout":"eca9e5cc59 _2cab9d4abe _2bd3b8f1dc","h_slide":"_24f6c2c5e7","category":"_02a9b050c6 f543457993 _076bbd5485"};